import csCZLang from './cs.js'
import skSKLang from './sk.js'
import huHULang from './hu.js'
import csHULang from './cs_HU.js'
import csSKLang from './cs_SK.js'
import skCZLang from './sk_CZ.js'
import skHULang from './sk_HU.js'
import ukCZLang from './uk_CZ.js'
import ukSKLang from './uk_SK.js'
import ukHULang from './uk_HU.js'
import ruCZLang from './ru_CZ.js'
import ruSKLang from './ru_SK.js'
import ruHULang from './ru_HU.js'
import enCZLang from './en_CZ.js'
import enSKLang from './en_SK.js'
import enHULang from './en_HU.js'
import huCZLang from './hu_CZ.js'
import huSKLang from './hu_SK.js'

// Local dev overrides from lang/temp.json — staged keys waiting for Lokalise sync.
// File is gitignored; glob silently yields an empty map when absent.
const tempOverrides =
  Object.values(import.meta.glob('./temp.json', { eager: true, import: 'default' }))[0] ?? {}

const isPlainObject = value =>
  value !== null && typeof value === 'object' && !Array.isArray(value)

const deepMerge = (target, source) => {
  const result = { ...target }
  for (const key of Object.keys(source)) {
    result[key] =
      isPlainObject(source[key]) && isPlainObject(result[key])
        ? deepMerge(result[key], source[key])
        : source[key]
  }
  return result
}

const bundles = {
  csCZLang, csHULang, csSKLang,
  skCZLang, skHULang, skSKLang,
  ukCZLang, ukHULang, ukSKLang,
  ruCZLang, ruHULang, ruSKLang,
  enCZLang, enHULang, enSKLang,
  huCZLang, huHULang, huSKLang
}

for (const key of Object.keys(bundles)) {
  const baseLocale = key.slice(0, 2)
  if (tempOverrides[baseLocale]) {
    bundles[key] = deepMerge(bundles[key], tempOverrides[baseLocale])
  }
}

export const langs = bundles
